import React, { Component } from "react";

import { ReactComponent as Logo } from "../CheckoutProcess/assets/browser.svg";

import { connect } from "react-redux";

import ProductHeader from "../ProductDetails/ProductHeader";
import ActionButton from "../ActionButton";
import { isValidPhoneNumber } from "react-phone-number-input";

import { saveCustomerContact, saveLastOrder } from "../../store/actions";
import PaymentMethod from "../CheckoutProcess/Confirmation/PaymentMethod";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Sentry from "@sentry/react";
import instance from "../../store/actions/instance";
import MuiPhoneNumber from "material-ui-phone-number";

//Actions

class index extends Component {
  state = {
    method: "none",
    amount: 0,
    phone: this.props.customerContact?.phone,
    paymentError: false,
    amountError: false,
    phoneError: false,
    tapCardError: "",
    loading: false,
  };

  componentDidMount = () => {
    this.loadTapCardComponent();
  };
  loadTapCardComponent = () => {
    if (!window.Tapjsli) return;
    const { language, settings } = this.props;

    if (!settings.tap_pk || !settings.enable_tap_v3_credit) return;
    var tap = window.Tapjsli(settings.tap_pk);

    window.tapObject = tap;
    var elements = tap.elements({});
    var style = {
      base: {
        color: "#535353",
        lineHeight: "18px",
        fontFamily: "sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "rgba(0, 0, 0, 0.26)",
          fontSize: "15px",
        },
      },
      invalid: {
        color: "red",
      },
    };
    // input labels/placeholders
    var labels = {
      cardNumber: "Card Number",
      expirationDate: "MM/YY",
      cvv: "CVV",
      cardHolder: "Card Holder Name",
    };
    //payment options
    var paymentOptions = {
      currencyCode: ["KWD", "USD", "SAR", "BHD", "OMR", "AED", "QAR"],
      labels: labels,
      TextDirection: "ltr",
    };
    //create element, pass style and payment options
    var card = elements.create("card", { style: style }, paymentOptions);
    window.tapCardObject = card;
    //mount element
    card.mount("#element-container");
    //card change event listener
    card.addEventListener("change", (event) => {
      if (event.status === "invalid") {
        this.setState({ tapCardError: "" });
      }
      if (event.BIN) {
      }
    });

    // // Handle form submission
    // var form = document.getElementById("form-container");
    // form.addEventListener("submit", (event) => {
    //   event.preventDefault();

    // });
  };
  handleChange = (value) => {
    if (this.state.method === value) {
      this.setState({
        method: "none",
      });
    } else {
      this.setState({ method: value, paymentError: false });
      if (value === "tap_v2_credit") {
        setTimeout(
          () =>
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: "smooth",
            }),
          200
        );
      }
    }
  };

  addCredit = async () => {
    const { language, settings } = this.props;
    if (this.state.method == "none") {
      this.setState({ paymentError: true });
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
      return;
    }

    if (!this.state.amount || this.state.amount <= 0) {
      this.setState({ amountError: true });
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
      return;
    }
    if (!isValidPhoneNumber(this.state.phone)) {
      this.setState({ phoneError: true });
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
      return;
    }
    this.setState({ loading: true });
    let tapV3Token = null;
    try {
      if (
        this.state.method === "tap_v2_credit" &&
        window.tapObject &&
        settings.enable_tap_v3_credit
      ) {
        const tapRes = await window.tapObject.createToken(window.tapCardObject);
        if (tapRes.error) {
          this.setState({
            tapCardError: tapRes.error.message,
            loading: false,
          });

          return;
        } else {
          tapV3Token = tapRes.id;
        }
      }

      const res = await instance.post(
        `/topup_promise_place/`,
        {
          paymentMethod: this.state.method,
          amount: this.state.amount,
          language: this.props.language,
          phoneNumber: this.state.phone,
          tapV3Token: tapV3Token,
        },
        {
          timeout: 30000,
        }
      );
      this.setState({ loading: false });
      if (res.data.paymentURL && res.data.paymentURL !== -1) {
        if (res.data.paymentURL != "Invalid") {
          this.props.saveLastOrder(res.data);
          window.location.href = res.data.paymentURL;
          return;
        } else {
          this.props.history.replace("/fail", {
            message:
              "The payment link could not be generated. Please contact us for help",
          });
          Sentry.captureException(
            new Error("Couldnt generate payment link"),
            (scope) => {
              scope.setExtra(
                "customer",
                JSON.stringify(this.props.customerContact)
              );
            }
          );
        }
      }
      if (res.data.message != "success" && !res.data.paymentURL) {
        this.props.history.replace("/fail", { message: res.data.message });
        Sentry.captureException(new Error(res.data.message), (scope) => {
          scope.setExtra(
            "customer",
            JSON.stringify(this.props.customerContact)
          );
        });
      }
    } catch (e) {
      this.props.history.replace("/fail", {
        message:
          language == "english"
            ? "Something wrong happened. Please try again, or contact us for help"
            : "حدث خطأ ما. الرجاء المحاولة مرة ثانية او تواصل معنا للمساعدة",
      });
      Sentry.captureException(e, (scope) => {
        scope.setExtra("customer", JSON.stringify(this.props.customerContact));
      });
    }
    this.setState({ loading: false });
  };
  render() {
    const { language, store, settings } = this.props;
    const { loading, amountError, phoneError, phone } = this.state;
    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };

    return (
      <div
        className="w-100 mx-0"
        style={{
          backgroundColor: "white",
          minHeight: 690,
        }}
      >
        <ProductHeader onBack={() => this.props.history.push("/profile")} />
        <div
          className="border-top w-100"
          style={{
            marginTop: 55,
            backgroundColor: "white",
          }}
        >
          <Logo width="100" height="100" style={{ marginTop: 98 }} />
          <p className="text-muted mt-3 mb-3 bold" style={{ fontSize: 22 }}>
            {language == "english" ? "Topup" : "Topup"}
          </p>
          <div style={{ marginTop: 35 }}></div>
          <PaymentMethod
            handleChange={this.handleChange}
            value={this.state.method}
            paymentError={this.state.paymentError}
            fromWallet={true}
          />
          <div
            className="my-5"
            style={{
              display: this.state.method === "tap_v2_credit" ? "block" : "none",
            }}
          >
            <p
              className="box-title"
              style={{ textAlign: language === "arabic" ? "right" : "left" }}
            >
              {language === "arabic" ? "تفاصيل البطاقة" : "Card Details"}
            </p>
            {this.state.tapCardError && (
              <p
                style={{
                  color: "red",
                  textAlign: "left",
                  padding: "0px 10px",
                  fontWeight: "bold",
                }}
              >
                * {this.state.tapCardError}
              </p>
            )}
            <form id="form-container" method="post" action="/charge">
              <div id="element-container"></div>
            </form>
          </div>
          <div>
            <p
              className="box-title"
              style={{ textAlign: language === "arabic" ? "right" : "left" }}
            >
              {language == "english" ? "Amount" : "المبلغ"}
            </p>

            <div
              className="w-100 mx-0 mb-3 py-2"
              style={{ backgroundColor: "white" }}
            >
              <div className="px-4">
                <TextField
                  error={amountError}
                  helperText={
                    amountError
                      ? language == "english"
                        ? "Please enter a valid amount"
                        : "الرجاء اختيار قيمة صحيحة"
                      : ""
                  }
                  id="standard-basic"
                  color={"#0099cc"}
                  onChange={(e) =>
                    this.setState({
                      amount: e.target.value,
                      amountError: false,
                    })
                  }
                  name="Amount"
                  type="number"
                  fullWidth
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <p
              className="box-title"
              style={{ textAlign: language === "arabic" ? "right" : "left" }}
            >
              {language == "english" ? "Phone" : "الهاتف"}
            </p>

            <div
              className="w-100 mx-0 mb-3 py-2"
              style={{ backgroundColor: "white" }}
            >
              <div className="px-4">
                <MuiPhoneNumber
                  defaultCountry={store.default_dial_code || "kw"}
                  onlyCountries={
                    settings.show_all_country_codes
                      ? []
                      : [
                          "kw",
                          "sa",
                          "qa",
                          "om",
                          "ae",
                          "bh",
                          "sy",
                          "lb",
                          "jo",
                          "eg",
                          "us",
                          "uk",
                          "cn",
                        ]
                  }
                  excludeCountries={["il"]}
                  countryCodeEditable={false}
                  disableAreaCodes={true}
                  error={phoneError}
                  autoComplete="tel"
                  //   label={language == "english" ? "Phone *" : "رقم الهاتف *"}
                  className="mt-4 mb-3"
                  color={"#0099cc"}
                  onChange={(e) =>
                    this.setState({ phone: e, phoneError: false })
                  }
                  value={phone}
                  fullWidth
                  helperText={
                    phoneError
                      ? language == "english"
                        ? "Please enter your phone number"
                        : "الرجاء ادخال رقم الهاتف"
                      : ""
                  }
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                />
              </div>
            </div>
          </div>
          <div style={{ height: 250, background: "white" }}></div>
          <ActionButton
            action={
              loading ? (
                <span>
                  <CircularProgress
                    style={{ width: 30, height: 30, color: "white" }}
                  />
                </span>
              ) : language == "english" ? (
                "Topup"
              ) : (
                "Topup"
              )
            }
            onClick={() => this.addCredit()}
            color="#0099cc"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customerContact: state.customers.customerContact,
    settings: state.store.store.settings,
    cart: state.cart,
    auth: state.auth,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCustomerContact: (customer) => dispatch(saveCustomerContact(customer)),
    saveLastOrder: (response) => dispatch(saveLastOrder(response)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
